<template>
    <div>
        <Nav bgColor="#FFFFFF" />
        <div class="d-flex align-items-center justify-content-center pt-3">
            <div class="d-flex align-items-center text-start text-white px-5">
                <span class="text-uppercase text-black fw-bold home-text mx-2 display-header text-center">Classes</span>
            </div>
        </div>
        <div class="container pt-2">
            <div class="mx-auto text-center" style="max-width: 1000px;">
                Find your fun and take a class with Atlas Improv! Our philosophy emphasizes character-based storytelling, and, through our classes, we
pass it on to our students. Besides being fun, comprehensive, diverse, and dynamic, our classes also build confidence, teamwork,
leadership, and decision-making skills. All classes meet at <a href="https://www.google.com/maps?q=609+E+Washington+Ave+Madison,+WI+53703" class="contact-link" target="_blank" rel="noopener">609 E Washington Ave Madison, WI 53703</a>.
Discounts are available for those with an active student ID, educators, active military/veterans, and others upon request. Have
Questions? Email us at <a href="mailto:edu@atlasimprov.com" class="contact-link">edu@atlasimprov.com</a> for more information.
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-center pt-5 pb-5">
            <a :href="`${$CLASS_URL}`">
                <div class="btn dark-btn ms-2 text-uppercase mb-5 site-black-bg text-white"
                    style="border-radius: 1; min-width: 180px;" type="button">Register</div>
            </a>
        </div>
        <div class="bg-dark w-100 mb-5" style="height: 2px;"></div>

        <AllClasses />
        <!-- <Carousel /> -->
        <PageSections :sectionId="2" />
        <!-- <div class="container-fluid" style="background-color: black;">
         <div class="row chalk-row">
             <div class="col-md-6 offset-md-3 d-flex flex-column align-items-center justify-content-center">
                 <div class="text-center chalk-outline">
                     <div class="fs-1 text-uppercase text-white"> Take a Class</div>
                     <div class="fs-1 text-uppercase text-white"> With atlas improv</div>
                 </div>
                 <div class="text-white text-center">Atlas Improv's philosophy emphasizes character-based
                     storytelling, and, through our classes, we pass it on to our students. Besides being fun,
                     comprehensive, diverse and dynamic, our classes also build confidence, teamwork, leadership and
                     decision-making skills.</div>
                 <div class="text-white py-3 p text-center"> Every Fall, Spring, and Summer Semester, we typically
                     offer improv Core Class, Advanced Short-form and Long-form classes.</div>
                 <div class="pt-5">
                     <div class="btn ms-2 text-uppercase text-white chalk-btn "
                         style="background-color: #1A95AC; border-radius: 0;" type="button">Learn More</div>
                     <div class="btn ms-2 text-uppercase text-white chalk-btn  "
                         style="background-color: #1A95AC; border-radius: 0;" type="button">Register</div>
                 </div>

             </div>

         </div>

     </div>
     <div class="container-fluid" style="background-color:rgb(246,206,55);">
         <div class="row flex-row-reverse">
             <div class="col-md-6">
                 <div class="our-story">
                     <div class='h1 text-uppercase'> Our Story</div>
                     <div class="py-3">Atlas Improv was founded in early 2004 by Mary Parmentier and Bryan Judkins.
                         Their dream was to explore and innovate beyond what was familiar. As managers Parmentier and
                         Judkins sought a creative environment that challenged and fulfilled us artistically. They
                         knew we were capable of more and wanted to push us to new heights. They realized short-form
                         wasn’t enough. In 2004, they Started Atlas Improv. The active mebers of ComedySportz -
                         Madison followed Parmentier to do something new and amazing.</div>
                     <div class="py-3">Today Atlas Improv fosters an expert in each of its players. In story arc,
                         character building, or pure wite, every performer is a master.</div>
                     <div class="btn text-uppercase text-white chalk-btn my-5 orange-back " type="button">Learn More
                     </div>
                 </div>
             </div>
             <div class="col-md-6">
                 <img :src="`${$API_ASSETS}4b23b7c6-fb4b-44cd-bb1f-f52b097724eb.png`"
                     class="img-fluid w-100 d-md-inline" alt="globe" />
             </div>
         </div>

     </div> -->
        <Footer />

    </div>



</template>

<script>
import { useHead } from '@vueuse/head';
import { useRoute } from 'vue-router';
import PageSections from '@/components/PageSections.vue';
import Footer from '../components/Footer.vue'
import Nav from "../components/Nav.vue"
import AllClasses from '@/components/AllClasses.vue';
// import Carousel from '@/components/Carousel.vue';
export default {
    name: 'Classes',
    setup() {
      const route = useRoute();
      useHead({
        title: route.meta.title || 'Atlas Improv – Classes',
        meta: [
          {
            name: 'description',
            content: route.meta.description || 'Discover and register for improv classes at Atlas Improv in Madison.'
          }
        ]
      });
      return {};
    },
    components: {
        Nav, Footer, PageSections, AllClasses
    },
};
</script>
